import { render, staticRenderFns } from "./WizardStep3.vue?vue&type=template&id=54839cd2"
import script from "./WizardStep3.vue?vue&type=script&lang=js"
export * from "./WizardStep3.vue?vue&type=script&lang=js"
import style0 from "./WizardStep3.vue?vue&type=style&index=0&id=54839cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports